export default __webpack_public_path__ + "static/media/registersuccessful.08e87ee1.png";